export const paths = {
    root: '/reportType',
    reportTypeList: '/reportType/list',
    actions: {
        create: '/reportType/createReportType',
        edit: '/reportType/editReportType/:reportId'
    }
};


export const navigation = {
    edit: (reportId) => `/reportType/editReportType/${reportId}`
}